// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

// --- HS Code
import {
  ImpersonationTokenValidationModel,
  ImpersonationValidationStages,
  TokenValidationErrorTypes,
} from '../../../models';
import { OidcService } from '../account/oidc.service';
import { ImpersonationValidationBaseService } from './impersonation-validation-base.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class ImpersonationValidationMockService extends ImpersonationValidationBaseService {
  constructor(oidcService: OidcService) {
    super(oidcService);
  }

  validateImpersonationToken(token: string): void {
    of(token)
      .pipe(delay(5000))
      .subscribe((result) => {
        if (result === 'error') {
          this._validationStage$.next(ImpersonationValidationStages.tokenError);
          this._validation$.next({
            tokenValue: '',
            hasPassword: false,
            tokenValidationErrorType: TokenValidationErrorTypes.unexpectedError,
            locale: '',
            applicationError: {
              errorMessage: 'errorHeaderUnexpected',
              detailedMessage: 'impersonationValidationUnexpectedError',
            },
          } as ImpersonationTokenValidationModel);
          return;
        }
        this._authenticateFromOtac('');
      });
  }
}
